import { WorkDay } from '../types'
import { VACATION_PROJECT_NAME } from '../constants/projectAcronyms'
import { getDurationString } from './worklogUtils'

export const sumProjectPerDay = (worklog: WorkDay | undefined, projectId: string, date: string): number => {
  if (worklog === undefined || projectId === '') return 0

  return worklog.date === date
    ? worklog.entries
        .filter(entry => entry.project.id === projectId)
        .reduce((accumulator, entry) => accumulator + entry.hours, 0)
    : 0
}

export const sumAllPerDay = (worklog: WorkDay | undefined, date: string): number => {
  if (worklog === undefined) return 0

  const projects = [...new Set(worklog.entries.map(entry => entry.project.id))]

  return projects.reduce((accumulator, project) => {
    return accumulator + sumProjectPerDay(worklog, project, date)
  }, 0)
}

export const getVacationId = (worklog: WorkDay | undefined): string => {
  if (!worklog) return ''

  const vacationProject = worklog.entries.find(entry => entry.project.name === VACATION_PROJECT_NAME)

  return vacationProject ? vacationProject.project.id : ''
}

export const formatHours = (hours: number): string => {
  if (hours === 0) return ''

  const formatted = getDurationString(hours)
  return formatted === '-' ? '' : formatted
}
